import ShopperTraining from '../src/components/sections/ShopperTraining';

export default ShopperTraining;
